// Indian INR formatting utilities

export function inr(value, opts = {}) {
  if (value === null || value === undefined || isNaN(value)) return "—";
  const { showSign = false, decimals = 0 } = opts;
  const sign = showSign && value > 0 ? "+" : "";
  return (
    sign +
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    }).format(value)
  );
}

export function pct(value, opts = {}) {
  if (value === null || value === undefined || isNaN(value)) return "—";
  const { showSign = true, decimals = 2 } = opts;
  const sign = showSign && value > 0 ? "+" : "";
  return `${sign}${Number(value).toFixed(decimals)}%`;
}

export function num(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) return "—";
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(value);
}
export function fmtDate(s) {
  if (!s) return "—";
  try {
    const d = typeof s === "string" ? new Date(s) : s;
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return s;
  }
}

export function isoDateInput(d = new Date()) {
  return d.toISOString().slice(0, 10);
}

export const profitColor = (v) =>
  v > 0 ? "text-profit" : v < 0 ? "text-loss" : "text-zinc-700";
